// Lib for making a js component that is keyboard navigable and aria-decorated.

// toggleControl: Element or selector for the control to toggle the accessible component,
// roleWrapper: Overall parent element that takes the aria role attribute, and receives focus to activate the component when toggleControl isn't set.
// ariaRole: The aria-role attribute to apply to the roleWrapper. Behaves somewhat differently if it is set to 'menu'
// items: Selector for selectable items,
// onActivate: Callback for when an component is activated,
// onDeactivate: Callback for when component is deactivated,
// onSelectItem: Callback for when item is focused,
// onEnterKey: Callback for when item has enter key pressed while focused,
// orientation: 'vertical' or 'horizontal'. Adjusts behavior of arrow keys for navigation.
// idPrefix: Prefix for generated ids.
// focusedClass: Class to add when item is focused.

jQuery.fn.accessibleScaffold = function(opts) {
	window.accessibility_uid = 0;
	var state = {
		currentFocusedItem: null,
		active: false
	};

	var defaults = {
		toggleControl: '',
		roleWrapper: 'nav',
		ariaRole: 'menu',
		items: '',
		roleWrapperVisibilityClass: 'visible',
		onActivate: function() {},
		onDeactivate: function() {},
		onSelectItem: function(item, index) {},
		onEnterKey: function(item, index) {},
		orientation: 'vertical',
		idPrefix: 'accessible-',
		focusedClass: 'focused'
	}

	opts = $.extend(defaults, opts);

	if (!opts.roleWrapper || !opts.items)
		return console.log('roleWrapper and items are required');

	var toggleControl = opts.toggleControl ? $(opts.toggleControl) : false;
	var applicationWrapper = $(this);
	var roleWrapper = applicationWrapper.find(opts.roleWrapper);
	var items = applicationWrapper.find(opts.items);

	var onKey = function(element, key, func) {
		var keys = {tab: 9, enter: 13, down: 40, up: 38, left: 37, right: 39, escape: 27};
		var bindings = element.data('bindings') || {};
		bindings[keys[key]] = func;
		element.data('bindings', bindings);

		if ($(element).data('listener')) return;

		element.data('listener', true);

		element.keydown(function (e) {
			if (bindings[e.which]) {
				e.stopImmediatePropagation(0);
				return bindings[e.which](e);
			}
		});
	}

	if (toggleControl) {
		toggleControl.click(function() {
			api.toggle()
			return false;
		});

		onKey(toggleControl, 'enter', function(e) {
			api.toggle();
			return false;
		});

		onKey(toggleControl, opts.orientation == 'vertical' ? 'down' : 'right', function() {
			api.activate();
			api.focusItem(items[0]);
			return false;
		});
	} else {
		onKey(applicationWrapper, 'enter', function(e) {
			api.activate();
			api.focusItem(items[0]);
			return false;
		});

		onKey(applicationWrapper, 'down', function() {
			api.activate();
			api.focusItem(items[0]);
			return false;
		});
	}

	onKey(roleWrapper, 'tab', function() {
		if (opts.ariaRole == 'menu') {
			api.deactivate();
			return false;
		} else {
			api.navigateNext();
			return false;
		}
	});

	onKey(roleWrapper, 'left', function() {
		api.navigatePrevious();
		return false;
	});

	onKey(roleWrapper, 'right', function() {
		api.navigateNext();
		return false;
	});

	onKey(roleWrapper, 'up', function() {
		api.navigatePrevious();
		return false;
	});

	onKey(roleWrapper, 'down', function() {
		api.navigateNext();
		return false;
	});

	onKey(roleWrapper, 'enter', function(e) {
		opts.onEnterKey(state.currentFocusedItem, items.index(state.currentFocusedItem));
		e.stopImmediatePropagation();
	});

	onKey(roleWrapper, 'escape', function() {
		api.deactivate();
		return false;
	});

	// Select menu sibling that starts with the letter/number pressed.
	roleWrapper.keydown(function(e) {
		var letter = String.fromCharCode(e.which);
		var pattern = /[\w\d]/;
		if (!letter || !pattern.test(letter)) return true;

		var current = null;
		var postMatches = [];
		var preMatches = [];
		$.each(items, function(i) {
			if (this == state.currentFocusedItem)
				return current = i;

			if ($(this).text().toLowerCase().startsWith(letter.toLowerCase())) {
				if (current) {
					postMatches.push(this);
				} else {
					preMatches.push(this);
				}
			}
		});

		matches = postMatches.concat(preMatches);
		api.focusItem(matches[0]);
		if (matches.length)
			return false;
	});

	var getUniqueId = function(slug) {
		window.accessibility_uid += 1;
		return opts.idPrefix + slug + '-' + window.accessibility_uid;
	}

	// Add Aria stuff
	var decorateMenu = function() {
		applicationWrapper.attr('role', 'application');
		var role = opts.ariaRole;

		if (role)
			roleWrapper.attr('role', role)

		var owns = [];
		$.each(items, function(i) {
			var newID = getUniqueId('item');
			owns.push(newID);
			$(this.element).attr('id', newID);
			$(this.element).attr('aria-posinset', i+1);
			$(this.element).attr('aria-setsize', items.length);
		});

		roleWrapper.attr('aria-owns', owns.join(' '));
	}

	// Make menu items not tab stops.
	var tabStopFix = function() {
		if (opts.ariaRole == 'menu') {
			items.attr('tabindex', -1);
			if (!toggleControl)
				applicationWrapper.attr('tabindex', 0);
		}
	}

	var api = applicationWrapper.api = {
		focusItem: function(item) {
			if (!item) return;

			state.currentFocusedItem = item;
			tabStopFix();
			$(item).attr('tabindex', 0).focus();
			items.removeClass(opts.focusedClass);
			$(item).addClass(opts.focusedClass);
			opts.onSelectItem(state.currentFocusedItem, items.index(state.currentFocusedItem));
		},

		navigate: function(dir) {
			if (!state.currentFocusedItem) return;

			var index = items.index(state.currentFocusedItem);
			var focusedItem = items[index + dir];
			if (focusedItem) {
				api.focusItem(focusedItem);
			} else {
				api.focusItem(items[dir == -1 ? items.length-1 : 0]);
			}
		},

		navigateNext: function() {
			api.navigate(1);
		},

		navigatePrevious: function() {
			api.navigate(-1);
		},

		toggle: function() {
			if (state.active) {
				api.deactivate()
			} else {
				api.activate()
			}
		},

		activate: function(i) {
			if (typeof i == 'undefined')
				i = 0;
			state.active = true
			roleWrapper.addClass(opts.roleWrapperVisibilityClass);
			opts.onActivate();
			api.focusItem(items[i]);
		},

		deactivate: function(doFocus) {
			doFocus = (typeof doFocus !== 'undefined') ?  doFocus : true;

			state.active = false
			roleWrapper.removeClass(opts.roleWrapperVisibilityClass);
			tabStopFix();
			state.currentFocusedItem = null;
			if (doFocus) {
				if (toggleControl) {
					toggleControl.focus();
				} else {
					applicationWrapper.focus();
				}
			}
			opts.onDeactivate();
		}
	}

	tabStopFix();
	decorateMenu();

	this.api = api;
	return this;
}
